import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../login/service-authen/authentication.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BreakpointObserver, Breakpoints, BreakpointState } from "@angular/cdk/layout"

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  isHandset : Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.Handset)
  username = this.authenticationService.getUser()
  hospital_name = JSON.parse(localStorage.getItem('hospital'))
  role = localStorage.getItem('role')
  checkRole: boolean = true
  checkRoleUser: boolean = true
  checkRoleAdmin: boolean = true
  constructor(
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit() {
    if (this.role == 'superadmin' || this.role == 'admin') {
      console.log(this.role);
      this.checkRole = true
    } else {
      this.checkRole = false
      // console.log(this.role);
    }
    if (this.role == 'user' || this.role == 'superadmin' || this.role == 'admin') {
      this.checkRoleUser = true
    } else {
      this.checkRoleUser = false
    }

    if (this.role == 'admin') {
      this.checkRoleAdmin = false
    } else {
      this.checkRoleAdmin = true
    }
  }

  dialog_reset_password() {
    const dialogRef = this.dialog.open(dialog_reset_password, {
      width: '40%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    })
  }

  redirectCXR3(){
    window.open("https://1ls.manageai.co.th/login", "_blank");
  }

}

@Component({
  selector: 'dialog_reset_password',
  templateUrl: 'dialog-reset-password.html',
  styleUrls: ['main.component.scss']
})
export class dialog_reset_password implements OnInit {
  // ceate form add
  formReset: FormGroup;
  resetAPI = `${environment.apiUrl}/users/reset`;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  hide = true;


  constructor(
    public dialogRef: MatDialogRef<dialog_reset_password>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar,
  ) {
    this.formResetPassword()
  }

  ngOnInit() {

  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  toggle_btn_password() {
    return this.hide = !this.hide
  }

  private formResetPassword() {
    this.formReset = this.formBuilder.group({
      username: ['', Validators.required],
      oldpassword: ['', [Validators.required]],
      newpassword: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*(?=.*[A-Z]+\w?)(?=.*[a-z]+\w?)(?=.*[0-9]+\w?)/), Validators.pattern(/^\w+$/), Validators.minLength(6)]],
    })
  }

  resetPassword() {
    // console.log(this.formReset.value.oldpassword);
    if (this.formReset.invalid) return
      this.http.put(this.resetAPI, this.formReset.value, this.httpOptions).subscribe(res => {
        this.onNoClick()
        this._snackBar.open('Reset password success.', 'Done', {
          duration: 10000,
        });
      }, err => {
        console.log(err);
        this._snackBar.open('Reset password fail!.', 'Done', {
          duration: 10000,
        });
      })
  }

}
